import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Storage from 'vue-ls'
import common from './util/common'
import moment from 'moment'
import 'moment/locale/zh-cn'

import componentsHandler from './util/iview.config'
import 'view-design/dist/styles/iview.css'
import '../my_theme/index.less'

const options = {
  namespace: 'XS__',
  name: 'ls',
  storage: 'local'
}
//Mod by LiuHui at 20201201 for cros begin
// const apiUrl = process.env.VUE_APP_APIURL
const apiUrl = process.env.VUE_APP_DOWNLOAD_URL
//Mod by LiuHui at 20201201 for cros begin
Vue.prototype.apiUrl = apiUrl
Vue.use(Storage, options)
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(componentsHandler)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
